import { attr, belongsTo, hasMany } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";
import type DpMeasuredJournalEvent from "./dp-measured-journal-event";

//---- Automatically generated, don't update this part ----

export default class DpSessionDeclaredJournalEvent extends JournalEvent {
  static override type = "dp-session-declared-journal-event";

  /**
   * specifies whether the session is in progress or completed
   */
  @attr("boolean", {
    allowNull: true
  })
  declare isDraft: boolean;

  @hasMany("dp-measured-journal-event", {
    async: false,
    inverse: "dpSessionDeclaredJournalEvent"
  })
  declare dpMeasuredJournalEvents: DpMeasuredJournalEvent[];

  static override validations(intl: IntlService) {
    return {
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.dp-session-declared-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée plus de 50 ans en avance. Veuillez modifier la date",
          onOrBefore: dayjs().add(50, "years").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----
  @belongsTo("patient", {
    async: false,
    inverse: "dpSessionDeclaredJournalEvents"
  })
  declare patient: Patient;

  get startMeasurement(): DpMeasuredJournalEvent | undefined {
    return this.dpMeasuredJournalEvents.find(
      m => m.moment === "start" && !m.isArchived
    );
  }

  get middleMeasurements(): DpMeasuredJournalEvent[] {
    return this.dpMeasuredJournalEvents.filter(
      m => m.moment === "middle" && !m.isArchived
    );
  }

  get endMeasurement(): DpMeasuredJournalEvent | undefined {
    return this.dpMeasuredJournalEvents.find(
      m => m.moment === "end" && !m.isArchived
    );
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "dp-session-declared-journal-event": DpSessionDeclaredJournalEvent;
  }
}
